import { SubNavigationEntry } from '@common/types/sub-navigation-entry';
import React, { FC, PropsWithChildren, useState } from 'react';
import { SubNavigationContext } from './sub-navigation-context';

export const SubNavigationProvider: FC<PropsWithChildren> = ({ children }) => {
  const [entries, setEntries] = useState<SubNavigationEntry[]>([]);
  const [hide, setHide] = useState<boolean | null>(false);
  const [overwriteRules, setOverwriteRules] = useState(false);

  return (
    <SubNavigationContext.Provider
      value={{
        entries,
        hide,
        overwriteRules,
        setEntries,
        setOverwriteRules,
        setHide
      }}
    >
      {children}
    </SubNavigationContext.Provider>
  );
};
